import jump from 'jump.js';

import OnLoadHelper from '@/scripts/old/helpers/OnLoadHelper';
import { findClosestElement, parseAttr } from '@/scripts/old/helpers/utils';

const NAMESPACE = 'data-scrollto';

class ScrollToModule {
  constructor() {
    this.initialized = false;

    this.onClickShim = (e) => {
      this.onClick(e);
    };

    OnLoadHelper.run(() => {
      this.init();
    });
  }

  init() {
    if (this.initialized) return;
    this.initialized = true;

    this.setEvents();
  }

  update() {
    this.init();
  }

  destroy() {
    this.setEvents(false);
    this.initialized = false;
  }

  setEvents(add = true) {
    const action = add ? 'addEventListener' : 'removeEventListener';
    document[action]('click', this.onClickShim);
  }

  onClick(e) {
    const trigger = findClosestElement(e.target, `[${NAMESPACE}]`);

    if (trigger) {
      e.preventDefault();

      const config = parseAttr(trigger, NAMESPACE);
      let options = {
        duration: 1000,
        offset: 0,
      };
      let target;

      if (typeof config === 'string') {
        target = document.querySelector(config);
      } else {
        target = document.querySelector(config.target);
        options = Object.assign(options, config);
      }

      if (!target) {
        console.warn('Scroll target not found');
        return;
      }

      jump(target, options);
    }
  }
}

export default new ScrollToModule();
